import { ReactNode } from 'react'
import styled from 'styled-components'

const LEGALITY_COLORS = {
  legal: '#3d8f52',
  banned: '#783131',
  restricted: '#999049',
  not_legal: '#6b6b6b',
}

type LegalityLabelProps = {
  legality: 'legal' | 'banned' | 'restricted' | 'not_legal'
  small?: boolean
  children?: ReactNode
}

export const LegalityLabel = ({ legality, small, children = null }: LegalityLabelProps) => {
  return (
    <div
      style={{
        width: small ? 60 : 90,
        height: 20,

        fontSize: '70%',
        borderRadius: 8,
        margin: 5,
        fontWeight: 'bold',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        whiteSpace: 'nowrap',
        overflow: 'hidden',

        background: LEGALITY_COLORS[legality] || LEGALITY_COLORS.not_legal,
        color: 'white',
      }}>
      {children}
    </div>
  )
}

export const LegalityBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`
